import { render, staticRenderFns } from "./TagGroup.vue?vue&type=template&id=3107ddac&"
import script from "./TagGroup.vue?vue&type=script&lang=js&"
export * from "./TagGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports